<template>
    <a-popover
        v-model:open="visible"
        :overlay-style="popoverStyle"
        trigger="click"
        :key="`${posX}-${posY}`"
    >
        <template #content>
            <div class="popover-content">
                <button class="close-btn" @click="closePopover" title="Fechar">
                    <i class="fas fa-times" aria-hidden="true"></i>
                </button>

                <div class="popover-body">
                    <div v-html="featureData.html"></div>
                    <a
                        v-if="featureData.matricula != null"
                        href="#"
                        class="popover-download-notif"
                        title="Baixar notificação desta matrícula"
                        @click.prevent="downloadNotificationByMatricula(featureData.matricula)"
                    >
                        <DownloadOutlined style="font-size: 18px;" /> Baixar notificação
                    </a>
                </div>

            </div>
        </template>
        <div ref="anchor" :style="anchorStyle"></div>
    </a-popover>

    <ModalsContainer :key="modalKey" />
</template>

<script setup>
import {ref, computed, defineExpose, markRaw, defineAsyncComponent, watch} from 'vue'
import {ModalsContainer, useModal} from "vue-final-modal";
import {DownloadOutlined} from '@ant-design/icons-vue';
import {message} from 'ant-design-vue';

import Browser from "../../Components/Browser.vue";
import ServicesAndActivities from "./ServicesAndActivities.vue";
import DefaultFrame from "../../Components/DefaultFrame.vue";
const modalKey = ref(0)
const browser = markRaw(Browser)
const street = markRaw(DefaultFrame)
const services = markRaw(ServicesAndActivities)

const emits = defineEmits(['hide'])

const visible = ref(false)
const featureData = ref({})
const posX = ref(0)
const posY = ref(0)

const anchor = ref(null)

const anchorStyle = computed(() => ({
    position: 'fixed',
    top: `${posY.value}px`,
    left: `${posX.value}px`,
    width: '1px',
    height: '1px',
    zIndex: 1000,
}))

const popoverStyle = computed(() => ({
    zIndex: 1001,
}))

function openPopover(data, pixelPos) {
    if (
        visible.value &&
        posX.value === pixelPos[0] &&
        posY.value === pixelPos[1]
    ) {
        featureData.value = { ...data }
        return
    }

    if (visible.value) {
        visible.value = false
        setTimeout(() => {
            featureData.value = { ...data }
            posX.value = pixelPos[0]
            posY.value = pixelPos[1]
            visible.value = true
        }, 10)
    } else {
        featureData.value = { ...data }
        posX.value = pixelPos[0]
        posY.value = pixelPos[1]
        visible.value = true
    }
}

function closePopover() {
    visible.value = false
}

watch(visible, (newVal, oldVal) => {
    if (oldVal === true && newVal === false) {
        emits('hide')
    }
})

const updatePopoverPosition = (pixel) => {
    posX.value = pixel[0]
    posY.value = pixel[1]
}

async function downloadNotificationByMatricula(matricula) {
    if (matricula == null) return
    try {
        const response = await window.axios.get(`/api/docs/notifications/by-matricula/${matricula}/download`, { responseType: 'blob' })
        const blob = response.data
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `notificacao-matricula-${matricula}.pdf`
        document.body.appendChild(a)
        a.click()
        a.remove()
        window.URL.revokeObjectURL(url)
        message.success('Download iniciado.')
    } catch (err) {
        let msg = 'Não foi possível baixar a notificação.'
        if (err.response?.data instanceof Blob) {
            try {
                const text = await err.response.data.text()
                const json = JSON.parse(text)
                msg = json?.message ?? msg
            } catch (_) {}
        } else if (err.response?.data?.message) {
            msg = err.response.data.message
        } else if (err.message) {
            msg = err.message
        }
        message.error(msg)
    }
}

defineExpose({ openPopover, closePopover, updatePopoverPosition })
</script>

<style scoped>
.buttons {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-top: 8px;
}

.popover-content {
    position: relative;
    padding-right: 24px; /* espaço para o botão fechar */
}

.popover-body {
    margin-top: 4px;
}

.popover-download-notif {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-top: 10px;
    padding: 6px 10px;
    font-size: 13px;
    color: #1890ff;
    text-decoration: none;
    border-radius: 4px;
}

.popover-download-notif:hover {
    color: #40a9ff;
    background: rgba(24, 144, 255, 0.08);
}

.close-btn {
    position: absolute;
    top: 4px;
    right: 4px;
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 14px;
    color: #666;
    padding: 2px 6px;
    line-height: 1;
    transition: color 0.2s;
}

.close-btn:hover {
    color: #000;
}
</style>
